// extracted by mini-css-extract-plugin
module.exports = {"compactWrap":"markdown_compactWrap__jGNcA","kind":"markdown_kind__tTzNe","peek":"markdown_peek__iqM2h","md":"markdown_md__GupJS"};